import request from '@/utils/request'
import ApiUrls from "@/api/apiUrls";

export function login(data) {
  return request({
    url: ApiUrls.LoginUrl,
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: ApiUrls.LoginUrl,
    method: 'post'
  })
}

export function getUserMenu() {
  return request({
    url:ApiUrls.UserInMenu,
    method:'post'
  });
}

export function getUserPermission() {
  return request({
    url:ApiUrls.GetUserPermission,
    method:'post'
  });
}

export function UserInfoForUser() {
  return request({
    url:ApiUrls.UserInfoForUser,
    method:'post'
  });
}
